import { UserRole } from '../types/keycloak'

export const hasRole = (roles: string[], requiredRole: UserRole): boolean => {
  return roles.includes(requiredRole)
}
export const getValidRoles = (roles: string[]): string[] => {
  return roles.filter((role) =>
    Object.values(UserRole).includes(role as UserRole)
  )
}
